export default "__VITE_ASSET__ad044e8b__"